import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get the user from localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // If we have a token, add it to the request headers
    if (user && user.stsTokenManager && user.stsTokenManager.accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.stsTokenManager.accessToken}`
        }
      });
    }
    
    return next.handle(request);
  }
} 